const team = {
  header: {
    title: "الفريق والوصول إلى مساحات العمل",
    description: "لكل عضو مساحة عمل معزولة لتنظيم المحتوى ونشره، تشمل مصادره وفلاتره وإعدادات الذكاء الاصطناعي والمنشورات المراقبة وصندوق المحتوى وحالة المراجعة وسجل النشر واعتماد بوت تيليجرام والوجهات. تظل إدارة الفريق وإعدادات النظام من صلاحيات المشرف العام.",
    currentAdministrator: "مسؤول النظام الحالي",
    superAdminFallback: "المشرف العام",
  },
  isolation: {
    inboxTitle: "صندوق محتوى خاص",
    inboxDescription: "التعديلات والموافقات والأرشيف ونتائج النشر والسجل تخص هذا العضو فقط.",
    destinationsTitle: "وجهات خاصة",
    destinationsDescription: "يمتلك كل عضو اعتماد بوت تيليجرام وقائمة وجهات منفصلة.",
    setupTitle: "إعداد تنسيق خاص",
    setupDescription: "يتحكم كل عضو في مصادر وفلاتر وتفضيلات ذكاء اصطناعي وسجلات منشورات مراقبة منفصلة.",
  },
  form: {
    title: "إضافة عضو إلى مساحة العمل",
    description: "تستخدم الحسابات الجديدة Supabase Auth وتحصل على مساحة عمل شخصية منفصلة.",
    email: "البريد الإلكتروني",
    emailPlaceholder: "member@example.com",
    emailHelp: "يصبح البريد الإلكتروني هوية Supabase الدائمة المستخدمة لعزل البيانات الشخصية.",
    password: "كلمة مرور مؤقتة",
    passwordPlaceholder: "8 أحرف على الأقل",
    role: "دور الوصول",
    roles: {
      adminOption: "مشرف — تنسيق ونشر شخصي",
      superAdminOption: "مشرف عام — مساحة شخصية + إدارة النظام",
      adminTitle: "صلاحيات المشرف",
      superAdminTitle: "صلاحيات المشرف العام",
      adminDescription: "يحصل على مصادر وفلاتر وتفضيلات ذكاء اصطناعي ومنشورات مراقبة وصندوق محتوى ووجهات وسجل نشر خاصة.",
      superAdminDescription: "يحصل على مساحة تنسيق خاصة بالكامل بالإضافة إلى صلاحية إدارة أعضاء الفريق وصحة النظام.",
    },
    submit: "إنشاء عضو مساحة العمل",
    submitting: "جارٍ إنشاء العضو…",
  },
  feedback: {
    validEmail: "أدخل بريدًا إلكترونيًا صالحًا. يستخدم الأعضاء الجدد Supabase Auth.",
    passwordLength: "يجب أن تتكون كلمة المرور المؤقتة من 8 أحرف على الأقل.",
    provisionSuccess: "تم إنشاء العضو “{{identity}}” مع مساحة تنسيق ونشر خاصة بالكامل.",
    provisionFailed: "تعذر إنشاء عضو مساحة العمل هذا.",
    revokeConfirm: "إلغاء وصول “{{identity}}”؟ ستبقى مصادره وفلاتره وتفضيلات الذكاء الاصطناعي والمنشورات المراقبة وصندوق المحتوى والوجهات وسجل النشر محفوظة للتدقيق/الاسترداد، لكنه لن يتمكن من تسجيل الدخول.",
    revokeSuccess: "تم إلغاء وصول “{{identity}}”. تم الاحتفاظ ببيانات مساحة العمل الشخصية.",
    revokeFailed: "تعذر إلغاء الوصول. تأكد من أنك لا تلغي وصولك أنت أو آخر مشرف عام.",
    revokeAccountFailed: "تعذر إلغاء وصول هذا الحساب.",
  },
  members: {
    title: "أعضاء مساحة العمل",
    summary: "{{active}} نشط · {{total}} إجمالي",
    legacySuffix: " · {{legacy}} قديم",
    isolationEnabled: "عزل مساحات العمل الشخصية مفعّل",
    legacyTitle: "لا تزال هناك حسابات قديمة",
    legacyDescription: "تبقى متوافقة وتستخدم اسم مستخدم موحدًا كمفتاح لمساحة العمل الشخصية. يجب إنشاء الأعضاء الجدد بالبريد الإلكتروني لربط الملكية بمعرّف Supabase ثابت.",
    you: "أنت",
    roles: {
      superAdmin: "مشرف عام",
      admin: "مشرف",
    },
    status: {
      active: "نشط",
      revoked: "ملغى",
    },
    added: "أُضيف {{date}}",
    providers: {
      supabase: "Supabase Auth",
      legacy: "هوية قديمة",
    },
    privateWorkspace: "صندوق محتوى + وجهات خاصة",
    legacyWarning: "ملكية مساحة العمل القديمة تعتمد على اسم المستخدم. استخدم حساب بريد/Supabase للأعضاء الجدد.",
    revoke: "إلغاء الوصول",
    emptyTitle: "لم يتم العثور على أعضاء",
    emptyDescription: "أنشئ أول حساب من النموذج.",
  },
} as const;

export default team;
